import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LotWatchRequestBuyButtonComponent } from './lot-watch-request-buy-button.component';
import { LotWatchRequestBuyModalComponent } from './components/lot-watch-request-buy-modal/lot-watch-request-buy-modal.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule } from 'ng-zorro-antd/modal';

import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@NgModule({
  imports: [
    CommonModule,
    NzButtonModule,
    TranslateModule,
    NzModalModule,
    NzAlertModule,
    NzSpinModule,
  ],
  declarations: [LotWatchRequestBuyButtonComponent, LotWatchRequestBuyModalComponent],
  exports: [LotWatchRequestBuyButtonComponent],
})
export class LotWatchRequestBuyButtonModule {}
